import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Switch,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
} from "@mui/material";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { I18n } from "aws-amplify/utils";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";

function UnrecMailPopup({ isOpen, onClose, email }) {
   return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{ "& .MuiDialog-paper": { width: "40%", maxWidth: "none" } }}
    >
      <DialogContent>
        <Box sx={{ mb: 1, fontSize: 18 }}>
            <List>
                <Box>
                  <ListItem>
                    <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {I18n.get("Receive date: ")}
                      </Typography>
                      {email.timestamp === undefined ? <Typography variant="body2"> {email.receive_date}</Typography> : <Typography variant="body2"> {email.timestamp}</Typography>}
                    </Box>
                  </ListItem>
                    {email.preprocessing_date !== undefined ? <div>
                        <Divider sx={{ marginY: 1 }} />
                        <ListItem>
                            <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                            <Typography variant="subtitle2" fontWeight="bold">
                                {I18n.get("Email Address: ")}
                            </Typography>
                            <Typography variant="body2"> {email.email_from}</Typography>
                            </Box>
                        </ListItem></div> : null}
                    {email.receive_date !== undefined ? <div>
                    <Divider sx={{ marginY: 1 }} />
                    <ListItem>
                        <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                        <Typography variant="subtitle2" fontWeight="bold">
                            {I18n.get("Receive date: ")}
                        </Typography>
                        <Typography variant="body2"> {email.receive_date}</Typography>
                        </Box>
                    </ListItem></div> : null}
                  <Divider sx={{ marginY: 1 }} />
                  
                  <ListItem>
                    <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                      <Typography variant="subtitle2" fontWeight="bold" fontSize={16}>
                        {I18n.get("Subject: ")}
                      </Typography>
                      <Typography variant="body2"> {email.subject}</Typography>
                    </Box>
                  </ListItem>
                  <Divider sx={{ marginY: 1 }} />
                  <ListItem>
                    <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                      <Typography variant="body2"> {parse(DOMPurify.sanitize(email.body))} </Typography>
                      </Box>
                  </ListItem>
                </Box>
            </List>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={onClose}>{I18n.get("Close")}</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

UnrecMailPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  email: PropTypes.array.isRequired,
};

export default UnrecMailPopup;
